import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
    state() {
        return {
            SurveyForm_id: null
        };
    },
    mutations,
    actions,
    getters
}